import { render, staticRenderFns } from "./ProtestPayoutActivity.vue?vue&type=template&id=12fafee4&"
import script from "./ProtestPayoutActivity.vue?vue&type=script&lang=js&"
export * from "./ProtestPayoutActivity.vue?vue&type=script&lang=js&"
import style0 from "./ProtestPayoutActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports